export const hasChosenLocation = () => {
  const localValue = localStorage.getItem('chosenLocation');
  return localValue && localValue === '1';
};
